import PaymentTypes from "./paymentTypes";

export default PaymentTypes;
